import * as PIXI from 'pixi.js';
import {getNearestTierTexture, Ship} from '@game/ships/ship';
import {HullSize, ShipGameObject} from '@game/ships/ship.game-object';
import {ExhaustGameObject} from '@game/ships/parts/exhaust.game-object';
import {ShipCreateOptions} from '@game/ships/ship.factory';

export class DestroyerWolfGameObject extends ShipGameObject {

  constructor(ship: Ship, opts: ShipCreateOptions) {
    super(ship, opts);

    // Left
    this.addExhaust(new ExhaustGameObject({
      track: this.ship,
      placement: -1,
      x: -5,
      y: 45,
      scale: 2,
    }));

    // Right
    this.addExhaust(new ExhaustGameObject({
      track: this.ship,
      placement: 1,
      x: 9,
      y: 45,
      scale: 1.8,
    }));

    const shipTexture = getNearestTierTexture(ship.getHighestModuleTier(), 'ships', 'destroyer_wolf_t%.png')
    if (shipTexture) {
      const sprite = new PIXI.Sprite(shipTexture);
      this.addChild(sprite);
    }
  }

  getSize(): number {
    return HullSize.Normal;
  }
}
